// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"e474df28","355":"b599a66e"}[chunkId] + ".chunk.css";
};